__turbopack_context__.v({
  "asterisk": "_7GbgWG_asterisk",
  "badge": "_7GbgWG_badge",
  "badgeCaret": "_7GbgWG_badgeCaret",
  "badgeIcon": "_7GbgWG_badgeIcon",
  "badgeLabel": "_7GbgWG_badgeLabel",
  "badgeRow": "_7GbgWG_badgeRow",
  "benefit": "_7GbgWG_benefit",
  "benefitSub": "_7GbgWG_benefitSub",
  "benefitTitle": "_7GbgWG_benefitTitle",
  "benefits": "_7GbgWG_benefits",
  "body": "_7GbgWG_body",
  "bottomFade": "_7GbgWG_bottomFade",
  "content": "_7GbgWG_content",
  "copy": "_7GbgWG_copy",
  "copyReveal": "_7GbgWG_copyReveal",
  "cta": "_7GbgWG_cta",
  "ctaGlass": "_7GbgWG_ctaGlass",
  "ctaRow": "_7GbgWG_ctaRow",
  "heroes": "_7GbgWG_heroes",
  "heroesBrand": "_7GbgWG_heroesBrand",
  "heroesDivider": "_7GbgWG_heroesDivider",
  "heroesIdme": "_7GbgWG_heroesIdme",
  "heroesLabel": "_7GbgWG_heroesLabel",
  "heroesPill": "_7GbgWG_heroesPill",
  "mediaContainer": "_7GbgWG_mediaContainer",
  "priceLine": "_7GbgWG_priceLine",
  "purchase": "_7GbgWG_purchase",
  "section": "_7GbgWG_section",
  "sep": "_7GbgWG_sep",
  "textGroup": "_7GbgWG_textGroup",
  "title": "_7GbgWG_title",
  "topFade": "_7GbgWG_topFade",
  "v1": "_7GbgWG_v1",
  "v2": "_7GbgWG_v2",
  "v3": "_7GbgWG_v3",
});
